import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons/index';
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons/index';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome/index';
import { requestLeaderBoard } from "../../store/actionCreators/leaderboard";
import Header from "../Units/Header";
import '../../assets/stylesheets/LeaderBoard/LeaderBoard.scss'
import Avatar from "../Units/Avatar";
import {getAccountAvatars} from "../../store/selectors";


const LeaderBoard = props => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const avatarList = useSelector(getAccountAvatars);
    const [selectedPeriod, setPeriod] = useState('monthly');
    const globalAccount = useSelector(state => state.globalAccount);
    const leaderboardList = useSelector(state => state.leaderboardList);
    const userLeadership = useSelector(state => state.userLeadership);

    const periods = [t('leaderboard.daily'), t('leaderboard.weekly'), t('leaderboard.monthly')];


    useEffect( () => {
        const skinId = globalAccount.clubId;
        dispatch(requestLeaderBoard({selectedPeriod, skinId}))
    }, [selectedPeriod]);

    return (
            <div className={'leaderboard'}>
                <div className="headerContainer">
                    <Header title='leaderboardTitle' backTo={'/'} ></Header>
                    <Link to="/leaderboard/info" className="infoLink"></Link>
                </div>
                <div className={'periodChoice'}>
                    {
                        periods.map((period, index) => <div key={index} className={`period ${period}Period ${(selectedPeriod === period) ? 'selected' : ''}`} onClick={() => setPeriod(period)}>{period}</div>)
                    }
                </div>
                <div className={'userStatistic'}>
                    <div className={'pointsWrapper'}>
                        <span className={'pointsIcon'}></span>
                        <div className={'points'}>
                            <span className={'title'}>{t('leaderboard.points')}</span>
                            <span className={'amount'}>{userLeadership.yourPoints}</span>
                        </div>
                    </div>
                    <div className={'timerWrapper'}>
                        <div className={'timer'}>
                            <span className={'title'}>{t('leaderboard.remaining')}</span>
                            <span className={'amount'}>{userLeadership.timeRemaining}</span>
                        </div>
                        <span className={'timerIcon'}></span>
                    </div>
                </div>
                <div className={'listCaption'}>
                        <div className={'rank'}>{t('leaderboard.rank')}</div>
                        <div className={'info'}>{t('leaderboard.name')}</div>
                        <div className={'points'}>{t('leaderboard.points')}</div>
                        <div className={'reward'}>{t('leaderboard.reward')}</div>
                    </div>
                    <div className="leaderBoardList scrollable">
                        {
                            leaderboardList.map((player, index) =>
                                <div key={index} className={'playerItemBoard'}>
                                    <div className={'playerRank'}>
                                        <span>{player.position}</span>
                                    </div>
                                    <div className={'playerInfo'}>
                                        <div className={`playerAvatar`}>
                                            <Avatar data={avatarList[player._id]} />
                                        </div>
                                        <div className={`playerNameSection`}>
                                            <span className={`playerName`}>{player.username}</span>
                                        </div>
                                    </div>
                                    <div className={'playerPoints'}>
                                        <span className={'pointsAmount'}>{player.point}</span>
                                    </div>
                                    <div className={'playerReward'}>
                                        <span className={`rewardIcon ${player.reward && player.reward.currency}`}></span>
                                        <span className={`rewardAmount reward${player.reward && player.reward.currency}`}>{player.reward && player.reward.amount}</span>
                                    </div>
                                </div>
                            )
                        }
                    </div>
            </div>
    );
}

export default LeaderBoard;
